<template>
	<div>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Other Charges</v-toolbar-title>

		    <v-spacer></v-spacer>

		    <v-btn icon @click="fn_new"><v-icon>add</v-icon></v-btn>

		    <v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" @input="fn_debounceSearch" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
		</v-toolbar>

		<div class="hasToolbar hasExtension grey-back" v-scroll="onScroll">


			<v-list nopadding grey-back>

				<v-subheader white-background subheader-ultra-dense>
					Count: {{$root.numberToLocale(listItemObject.totalCount, 1)}}
				</v-subheader>

				<v-divider></v-divider>

				<div white-background v-for="(item, index) in listItemObject.items" :key="index" :id="'item_'+item.addOnsId">
					<v-list-tile class="right-subtitle-tile">
					    <v-list-tile-content @click="fn_itemClick(item.addOnsId, index)">
					      <v-list-tile-title class="mb-1">{{item.name}}</v-list-tile-title>
					    </v-list-tile-content>

					    <v-list-tile-action>
					    	<v-btn icon flat @click="fn_getBottomMenu(null, 902, item)">
				                <v-icon>more_vert</v-icon>
				            </v-btn>
					    </v-list-tile-action>
					</v-list-tile>

					<v-divider v-if="listItemObject.items.length-1 != index"></v-divider>
				</div>


			</v-list>

			<transition name="fade" mode="out-in">

				<v-card noshadow class="create-placeholder-card" v-if="showPlaceHolder && !listItemObject.totalCount">
					<v-card-text>

						<div center-align>
			            	<div @click="fn_new" v-ripple class="placeholder-icon">
			            		<i aria-hidden="true" class="v-icon material-icons add-icon">add</i>
			            		<img src="../../../../assets/icon_wallet.svg" alt="">
			            	</div><br>

			            	<p class="title light-opacity-color">Create New Charges</p>
			            </div>
					</v-card-text>
				</v-card>
				
				<!-- <v-card noshadow v-if="showPlaceHolder && !listItemObject.totalCount" style="height: calc(100vh - 162px);display: flex;align-items: center;">
					<v-card-text>

						<div center-align>
			            	<div @click="fn_new" v-ripple style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px;position:relative">
			            		<i aria-hidden="true" class="v-icon material-icons" style="position: absolute;top: 0;right: 0px;background: #4b77be !important;border-radius: 50%;color: #fff !important;font-size: 20px;">add</i>
			            		<img src="../../../../assets/icon_wallet.svg" style="opacity:0.6;width:42px" alt="">
			            	</div><br>

			            	<p class="title light-opacity-color" style="line-height:28px !important">Create New Other Charges</p>
			            </div>

					</v-card-text>
				</v-card> -->
			</transition>

			<!-- <div class="display_msg" v-if="!listItemObject.items.length">There are no items</div> -->
		</div>
	</div>
</template>

<script>
var tagId = null;
const menuItem = require('../../../../config.js').configs.menuItem;
const bottomSheetMenu = require('../../../../config.js').configs.bottomSheetMenu;
import {masterMixin} from '../../master_mixin.js'

	export default{
		mixins: [masterMixin],
		data(){
			return {
				selectedItemId:null
			}
		},
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

			fn_new: function(){
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = this.listItemObject.items.length;
          		localStorage.setItem("master_items_state", JSON.stringify(obj));

				this.$router.push({path:'/addons/othercharges/new', query:{tagId:this.guidWeb()}});
			},

			fn_menuItemClick: function(tagId, menuId, menuAction, itemId){
				// tagId id form future use
				// menuId id form future use
				if(menuAction=='edit'){
					this.$router.push("/addons/othercharges/"+this.selectedItemId+"/edit");
				}
				else if(menuAction=='copy'){
					this.$router.push({path:'/addons/othercharges/new', query:{tagId:this.guidWeb(), itemId:this.selectedItemId, copy:true}});
				}
				else if(menuAction=='draft'){
					// this.$router.push({path:'/drafts', query:{category:"Other Charges", tabIndex:0}});
					this.$router.push({path:'/drafts', query:{tabIndex:0}});
				}
				else if(menuAction=='delete'){
					let self = this;
					this.fn_deleteMasterItem('addOns', itemId, function(response){
						if(response){
	                        self.showToast('Item deleted');
	                    }
	                    else{
	                        self.showToast("Item cannot be deleted as already in use");
	                    }
					})
				}
			},

			fn_itemClick: function (itemId, index) {
				// tagId id form future use
				// itemName id form future use
				let obj = {};
				obj.itemId = null;
				obj.lastScrollPos = window.pageYOffset;
				obj.itemIndex = index + 1;
				localStorage.setItem("master_items_state", JSON.stringify(obj));

				this.$router.push('/addons/othercharges/'+itemId);
			},

			fn_getBottomMenu: function (tagId, elementId, item) {
				let bottomMenu;

				if(elementId == bottomSheetMenu.toolBar.Id){
					bottomMenu = {"BottomMenu": [menuItem.help]};
				}
				else if(elementId == bottomSheetMenu.masterListItems.Id){
					bottomMenu = {"BottomMenu": [menuItem.edit, menuItem.copy]};
					this.selectedItemId = item.addOnsId;
					// !Number(isSystem) ? bottomMenu.BottomMenu.push(menuItem.delete) : '';
				}

				this.setBottomMenu(this.$route.query.tagId, bottomMenu, 
					{
						onSuccess: function (response) {
							console.log(response);
						},
						onError: function (error) {
							console.log(error);
						}
					}
				)
			},

			fn_loadItems: function(search) {
				this.loadMore = true;
		    	let filterObject = {};
				filterObject.limit = 50;
				filterObject.startIndex = this.startIndex;
				filterObject.search = this.searchValue ? this.searchValue.toLowerCase() : '';
				filterObject.addOnGroupId = 3;

		        let pageState = null;
				if(localStorage.getItem("master_items_state")){
					pageState = JSON.parse(localStorage.getItem("master_items_state"));
					filterObject.limit = 50 - (pageState.itemIndex % 50) + pageState.itemIndex;
				}

				let self = this;
				this.getItems("AddOnsList", filterObject, 
					{
						onSuccess: function (response) {
							console.log(response);
							let responseJson = JSON.parse(response);
							self.listItemObject.totalCount = responseJson.totalCount;

							search ? self.listItemObject.items = [] : '';

							let itemFound = false;
							for(let i in responseJson.items){
								if(pageState && pageState.itemId){
									if(responseJson.items[i].addOnsId == pageState.itemId){
										itemFound = true;
									}
								}

								let itemIndex = self.listItemObject.items.findIndex(item => item.addOnsId==responseJson.items[i].addOnsId);

								if(itemIndex==-1){
									self.listItemObject.items.push(responseJson.items[i]);	
								}
								
							}

							console.log(pageState);
							if(pageState && pageState.itemId){
								setTimeout(function(){
									if(itemFound){
										let scrollOptions = {"duration":0, "offset":-112, "easing":"linear"};
										self.$vuetify.goTo('#item_'+pageState.itemId, scrollOptions);
										localStorage.removeItem("master_items_state");
									}
									else{
										self.$vuetify.goTo(99999, self.scrollOptions);
									}
								},100);
							}

							if(pageState && !pageState.itemId){
								setTimeout(function(){
									let scrollOptions = {"duration":300, "offset":0, "easing":"linear"};
									self.$vuetify.goTo(pageState.lastScrollPos, scrollOptions);
									localStorage.removeItem("master_items_state");
								},100);
							}

							self.startIndex = self.listItemObject.items.length;
							self.loadMore = false;

							setTimeout(function(){
								self.showPlaceHolder = true;
							},300);
						},
						onError: function (error) {
							console.log(error);
							self.loadMore = false;
						}
					}
				)
		    },

		    fn_searchItem: function () {
				this.startIndex = 0;
				this.listItemObject.items = [];
				this.fn_loadItems(true);
			},

			fn_showWebView: function () {
				var viewObject = {};

				var tagId = null;
				this.$route.params && this.$route.query.tagId ? tagId = this.$route.query.tagId : '';
				var self = this;

				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null, 
				        onMenuItemClick: function (tagId, menuId, menuAction, itemId) {
							self.fn_menuItemClick(tagId, menuId, menuAction, itemId)
						}
					}
				);
			}
		},
		mounted: function(){

			this.fn_showWebView();
			window.js_globals.fn_onBackPress = this.fn_goBack;
			this.fn_loadItems();
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/other_charges/items.vue